angular.module('zc.projects')

.directive 'zcPageDescription', (ProjectPageDescription, Meta, BaseProjectCrudEditor) ->
  editor = new BaseProjectCrudEditor(
    ProjectPageDescription
    Meta
    '/templates/projects.settings/other/page_description.html'
  )

  return editor.createDirective()



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.settings/other/page_description.directive.coffee